(() => {
  const ANIMATED_BUTTON_SELECTOR = '#cart-drawer .cart__checkout-button, #cart-drawer .cart-items__empty-button, .twomatoes-cart-page-section .cart__checkout-button';
  const BACKGROUND_SELECTOR = '.page-wrapper, .twomatoes-header-section';
  const OVERLAY_CLASS = 'twomatoes-cart-click-overlay';
  const HEADER_ACTIVE_CLASS = 'twomatoes-cart-drawer-active';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const createGradientLayer = (className, layerName) => {
    const layer = document.createElement('span');
    layer.className = className;
    layer.dataset.twomatoesCartLayer = layerName;
    layer.setAttribute('aria-hidden', 'true');

    const ballOne = document.createElement('span');
    ballOne.className = 'button_gradient-ball ball-1';

    const ballTwo = document.createElement('span');
    ballTwo.className = 'button_gradient-ball ball-2';

    layer.append(ballOne, ballTwo);
    return layer;
  };

  const getCartLayer = (button, layerName) => Array.from(button.children).find((child) => child instanceof HTMLElement && child.dataset.twomatoesCartLayer === layerName);

  const resetCheckoutButtonText = (button) => {
    const text = button.querySelector('.button-text');
    if (!text) return;

    text.style.removeProperty('opacity');
    text.style.removeProperty('transition');
  };

  const animateGradientLayer = (layer) => {
    if (reducedMotion.matches || layer.dataset.twomatoesCartMotionReady === 'true') return;

    layer.dataset.twomatoesCartMotionReady = 'true';

    layer.querySelectorAll('.button_gradient-ball.ball-1').forEach((ball) => {
      ball.animate(
        [
          { transform: 'translate(0%, 0%) scale(1)' },
          { transform: 'translate(100%, 0%) scale(1)', offset: 0.25 },
          { transform: 'translate(100%, -100%) scale(1.5)', offset: 0.5 },
          { transform: 'translate(0%, -100%) scale(1.5)', offset: 0.75 },
          { transform: 'translate(0%, 0%) scale(1)' }
        ],
        {
          duration: 12000,
          iterations: Infinity,
          easing: 'linear'
        }
      );
    });

    layer.querySelectorAll('.button_gradient-ball.ball-2').forEach((ball) => {
      ball.animate(
        [
          { transform: 'translate(0%, 0%)' },
          { transform: 'translate(-100%, 0%)', offset: 0.25 },
          { transform: 'translate(-100%, -100%)', offset: 0.5 },
          { transform: 'translate(-100%, 0%)', offset: 0.75 },
          { transform: 'translate(0%, 0%)' }
        ],
        {
          duration: 16000,
          iterations: Infinity,
          easing: 'linear'
        }
      );
    });
  };

  const ensureCheckoutLayers = (button) => {
    let gradient = getCartLayer(button, 'gradient');
    let glow = getCartLayer(button, 'glow');

    if (!gradient || !gradient.classList.contains('button_gradient')) {
      gradient?.remove();
      gradient = createGradientLayer('button_gradient', 'gradient');
      button.insertBefore(gradient, button.firstChild);
      gradient.style.opacity = '0';
    }

    if (!glow || !glow.classList.contains('button_gradient-glow')) {
      glow?.remove();
      glow = createGradientLayer('button_gradient-glow', 'glow');
      button.appendChild(glow);
      glow.style.opacity = '0';
    }

    animateGradientLayer(gradient);
    animateGradientLayer(glow);
  };

  const setCurrentLayerOpacity = (button, gradientOpacity, glowOpacity) => {
    const gradient = getCartLayer(button, 'gradient');
    const glow = getCartLayer(button, 'glow');

    if (gradient?.classList.contains('button_gradient')) {
      gradient.style.transition = 'opacity 0.30s ease';
      gradient.style.opacity = String(gradientOpacity);
    }

    if (glow?.classList.contains('button_gradient-glow')) {
      glow.style.transition = 'opacity 0.30s ease';
      glow.style.opacity = String(glowOpacity);
    }
  };

  const initializeCheckoutAnimation = (button) => {
    if (!button) return;

    const text = button.querySelector('.button-text');
    if (!text) return;

    resetCheckoutButtonText(button);
    ensureCheckoutLayers(button);

    if (button.dataset.twomatoesCartButtonReady === 'true') return;

    button.dataset.twomatoesCartButtonReady = 'true';
    button.addEventListener('mouseenter', () => setCurrentLayerOpacity(button, 1, 0.25));
    button.addEventListener('mouseleave', () => setCurrentLayerOpacity(button, 0, 0));
    button.addEventListener('focusin', () => setCurrentLayerOpacity(button, 1, 0.25));
    button.addEventListener('focusout', () => setCurrentLayerOpacity(button, 0, 0));
  };

  const enhanceCartButtons = () => {
    document.querySelectorAll(ANIMATED_BUTTON_SELECTOR).forEach(initializeCheckoutAnimation);
  };

  const syncHeaderScrollbarWidth = () => {
    const pageWrapper = document.querySelector('.page-wrapper');
    if (!pageWrapper) return;

    const scrollbarWidth = Math.max(0, Math.round(pageWrapper.offsetWidth - pageWrapper.clientWidth));
    document.documentElement.style.setProperty('--twomatoes-page-scrollbar-width', `${scrollbarWidth}px`);
    document.documentElement.classList.add('twomatoes-header-layout-ready');
  };

  const isCartDrawerEvent = (event) => event.target instanceof HTMLElement && event.target.id === 'cart-drawer';

  const setHeaderDrawerState = (active) => {
    document.documentElement.classList.toggle(HEADER_ACTIVE_CLASS, active);
  };

  const syncInitialHeaderDrawerState = () => {
    setHeaderDrawerState(Boolean(document.querySelector('#cart-drawer[open]')));
  };

  document.addEventListener('theme-drawer:open', (event) => {
    if (!isCartDrawerEvent(event)) return;
    setHeaderDrawerState(true);
  });

  document.addEventListener('theme-drawer:close', (event) => {
    if (!isCartDrawerEvent(event)) return;
    setHeaderDrawerState(false);
  });

  const backgroundElements = new Set();

  const registerBackgroundElements = () => {
    document.querySelectorAll(BACKGROUND_SELECTOR).forEach((element) => {
      if (!(element instanceof HTMLElement)) return;
      backgroundElements.add(element);
    });
  };

  const setElementInert = (element, inert) => {
    if (inert) {
      if (!element.hasAttribute('data-twomatoes-cart-previous-inert')) {
        element.setAttribute('data-twomatoes-cart-previous-inert', element.inert ? 'true' : 'false');
      }

      element.inert = true;
      return;
    }

    const previousInert = element.getAttribute('data-twomatoes-cart-previous-inert');
    if (previousInert === null) return;

    element.inert = previousInert === 'true';
    element.removeAttribute('data-twomatoes-cart-previous-inert');
  };

  const getCartDrawer = () => document.querySelector('#cart-drawer');


  const disableNativeImmediateAutoOpen = () => {
    document.querySelectorAll('#cart-drawer cart-drawer-component[auto-open]').forEach((component) => {
      component.removeAttribute('auto-open');
    });
  };

  const openCartDrawer = () => {
    const cartDrawer = getCartDrawer();
    if (!cartDrawer || cartDrawer.hasAttribute('open')) return;

    if (typeof cartDrawer.open === 'function') {
      cartDrawer.open();
      return;
    }

    if (window.Shopify?.actions?.openCart) window.Shopify.actions.openCart();
  };

  const enhanceCartPageButtonAfterUpdate = (event) => {
    if (!event.promise) {
      window.requestAnimationFrame(enhanceCartButtons);
      return;
    }

    event.promise
      .then(() => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(enhanceCartButtons);
        });
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[twomatoes-cart-drawer] Cart page button refresh rejected:', error);
      });
  };

  const handleCartAddAfterRefresh = (event) => {
    if (event.action !== 'add' || !event.promise) return;

    const sourceModal = event.target instanceof Element ? event.target.closest('dialog:modal') : null;

    event.promise
      .then(({ detail }) => {
        if (detail?.didError) return;

        const openAfterLayout = () => {
          window.requestAnimationFrame(() => {
            window.requestAnimationFrame(openCartDrawer);
          });
        };

        if (sourceModal?.open) {
          sourceModal.addEventListener('close', openAfterLayout, { once: true });
        } else {
          openAfterLayout();
        }
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[twomatoes-cart-drawer] Cart update promise rejected:', error);
      });
  };

  const isCartDrawerActive = () => {
    const cartDrawer = getCartDrawer();
    const dialog = cartDrawer?.querySelector('.theme-drawer__dialog');
    return Boolean(cartDrawer?.hasAttribute('open') || dialog?.classList.contains('theme-drawer__dialog--closing'));
  };

  const syncBackgroundLock = () => {
    registerBackgroundElements();

    const cartDrawer = getCartDrawer();
    const isOpen = isCartDrawerActive();

    backgroundElements.forEach((element) => {
      if (cartDrawer && (element === cartDrawer || element.contains(cartDrawer))) return;
      setElementInert(element, isOpen);
    });
  };

  const closeCartDrawer = () => {
    const cartDrawer = getCartDrawer();
    if (!cartDrawer) return;

    if (typeof cartDrawer.close === 'function') {
      cartDrawer.close();
      return;
    }

    const closeButton = cartDrawer.querySelector('.theme-drawer__close-button');
    if (closeButton instanceof HTMLElement) closeButton.click();
  };

  const ensureClickOverlay = () => {
    let overlay = document.querySelector(`.${OVERLAY_CLASS}`);
    if (overlay instanceof HTMLElement) return overlay;

    overlay = document.createElement('div');
    overlay.className = OVERLAY_CLASS;
    overlay.setAttribute('aria-hidden', 'true');
    overlay.addEventListener('click', closeCartDrawer);
    document.body.appendChild(overlay);
    return overlay;
  };

  const drawerStateObserver = new MutationObserver(() => {
    syncBackgroundLock();
    ensureClickOverlay();
  });

  const observeDrawerState = () => {
    const cartDrawer = getCartDrawer();
    if (!cartDrawer) return;

    drawerStateObserver.disconnect();
    drawerStateObserver.observe(cartDrawer, {
      attributes: true,
      attributeFilter: ['open'],
      childList: true,
      subtree: true
    });

    ensureClickOverlay();
    syncBackgroundLock();
  };

  const observer = new MutationObserver(() => {
    disableNativeImmediateAutoOpen();
    ensureClickOverlay();
    enhanceCartButtons();
    syncBackgroundLock();
  });

  const initialize = () => {
    const cartDrawer = document.querySelector('#cart-drawer');

    if (cartDrawer) {
      observer.observe(cartDrawer, {
        attributes: true,
        attributeFilter: ['auto-open'],
        childList: true,
        subtree: true
      });
    }

    document.addEventListener('shopify:section:load', () => {
      disableNativeImmediateAutoOpen();
      syncHeaderScrollbarWidth();
      syncInitialHeaderDrawerState();
      observeDrawerState();
      enhanceCartButtons();
    });

    document.addEventListener('shopify:cart:lines-update', handleCartAddAfterRefresh);
    document.addEventListener('shopify:cart:lines-update', enhanceCartPageButtonAfterUpdate);
    window.addEventListener('resize', syncHeaderScrollbarWidth, { passive: true });
    disableNativeImmediateAutoOpen();
    syncHeaderScrollbarWidth();
    syncInitialHeaderDrawerState();
    observeDrawerState();
    enhanceCartButtons();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
